(() => {
  let RS_scheduled = false;

  function RS_getCounterEl() {
    return document.getElementById('RS-CollectionViewedCounter');
  }

  function RS_num(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }

  function RS_getViewedOnPage() {
    const items = document.querySelectorAll('#product-grid li.grid__item');
    return items ? items.length : 0;
  }

  function RS_setTextIfChanged(el, value) {
    const next = String(value);
    if (el && el.textContent !== next) el.textContent = next;
  }

  function RS_updateCounter() {
    const el = RS_getCounterEl();
    if (!el) return;

    const total = RS_num(el.dataset.rsTotal);
    const base = RS_num(el.dataset.rsBase);
    const onPage = RS_getViewedOnPage();

    const viewed = total ? Math.min(base + onPage, total) : (base + onPage);

    RS_setTextIfChanged(el.querySelector('[data-rs-viewed]'), viewed);
    RS_setTextIfChanged(el.querySelector('[data-rs-total]'), total);

    const display = total === 0 ? 'none' : '';
    if (el.style.display !== display) el.style.display = display;
  }

  function RS_scheduleUpdate() {
    if (RS_scheduled) return;
    RS_scheduled = true;
    requestAnimationFrame(() => {
      RS_scheduled = false;
      RS_updateCounter();
    });
  }

  function RS_observeGrid() {
    // KLUCZ: obserwuj tylko listę produktów, nie kontener z licznikiem
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const obs = new MutationObserver(() => RS_scheduleUpdate());
    obs.observe(grid, { childList: true, subtree: true });
  }

  function RS_init() {
    RS_updateCounter();
    RS_observeGrid();
    window.addEventListener('pageshow', RS_updateCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', RS_init);
  } else {
    RS_init();
  }
})();